import { archiverUrl, fetchWithAuthorization } from '../../helpers/utils';

const DatasourceParameterApi = {
    fetch: (timeRangeQS: string, instanceId: number): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/datasource/parameter?${timeRangeQS}&id=${instanceId}`),
    fetchComparison: (tz: string, from0: string, to0: string, id0: number, from1: string, to1: string, id1: number): Promise<Response> =>
        fetchWithAuthorization(`${archiverUrl()}/datasource/parameter/comparison?tz=${tz}&from=${from0}&to=${to0}&id=${id0}&from=${from1}&to=${to1}&id=${id1}`),
};

export default DatasourceParameterApi;
